import {Component, Input, OnInit} from '@angular/core';
import {AOutDescription} from "../analogoutDescription";
import {AOState} from "../analogoutStatus";
import {AnalogoutlistComponent} from "../analogoutlist/analogoutlist.component";

@Component({
  selector: 'app-analogoutdetails',
  templateUrl: './analogoutdetails.component.html',
  styleUrls: ['./analogoutdetails.component.css']
})
export class AnalogoutdetailsComponent implements OnInit {

  @Input()
  refNumber: number = -1;
  checked: boolean = false;
  aoDescription: AOutDescription;
  aoStatus: AOState;

  constructor(private analogoutlistComponent: AnalogoutlistComponent) {
    this.aoDescription = new AOutDescription();
    this.aoStatus = new AOState();
    this.checked = false;
    analogoutlistComponent.Add(this);
  }

  UpdateLayoutData(aoDescription: AOutDescription): void
  {
    this.aoDescription = aoDescription;
  }
  UpdateDiState(aoState: AOState): void
  {
    this.aoStatus = aoState;
    this.checked = (this.aoStatus.value) ? true :false;
  }

  ngOnInit(): void {
  }

  GetValue() : number
  {
      return ((this.aoStatus.value  * 100) /255);
  }
}
